<template>
  <div>
    <ContentHeader :showBack="true" />
    <div class="content-container" v-loading="loading">
      <div class="steps" v-if="detailInfo.publishStatus === 1">
        <el-steps :active="active" finish-status="success" align-center>
          <el-step title="待提交"></el-step>
          <el-step title="审批中"></el-step>
          <el-step title="生效中"></el-step>
          <el-step title="已结束"></el-step>
        </el-steps>
      </div>
      <div class="steps-disable" v-else>活动已禁用</div>
      <div class="title">
        <span>
          活动信息
          <span style="font-size:14px;color:#c8102d;">{{tips}}</span>
        </span>
        <!-- region -->
        <template v-if="employeeLevel <= 50">
          <div class="handle-box" v-if="detailInfo.publishStatus === 1">
            <!-- 待审批 -->
            <template v-if="detailInfo.themeStatus < 200">
              <el-button class="btn-red" @click="handleUpdate">修改</el-button>
              <el-button class="btn-red" @click="handleCopy">复制</el-button>
              <el-button class="btn-red" @click="handleRemove">删除</el-button>
            </template>
            <!-- 生效中 -->
            <template v-if="detailInfo.themeStatus === 200">
              <!-- 未修改、生效中修改审批通过、审批拒绝 -->
              <template v-if="detailInfo.modifyStatus === null || detailInfo.modifyStatus === 200 || detailInfo.modifyStatus === 900">
                <el-button class="btn-red" @click="handleCopy">复制</el-button>
              </template>
              <!-- 已修改未提交 -->
              <template v-if="detailInfo.modifyStatus === 0">
                <el-button class="btn-red" @click="updateApprove(0)">取消修改</el-button>
                <el-button class="btn-red" @click="updateApprove(2)">提交修改</el-button>
              </template>
              <!-- 已修改待审批 -->
              <template v-if="detailInfo.modifyStatus === 100">
                <el-button class="btn-red" @click="updateApprove(0)">取消修改</el-button>
                <el-button class="btn-red" @click="updateApprove(1)">召回修改</el-button>
              </template>
              <el-button class="btn-red" @click="handleDisable">禁用</el-button>
            </template>
          </div>
          <div class="handle-box" v-else>
            <el-button class="btn-red" @click="handleCopy">复制</el-button>
            <el-button class="btn-green" @click="handleEnable">启用</el-button>
          </div>
        </template>
        <!-- bu -->
        <template v-else>
          <div v-if="detailInfo.themeStatus === 100 || detailInfo.modifyStatus === 100">
            <el-button size="mini" type="danger" @click="allPass(200)">通过</el-button>
            <el-button size="mini" type="danger" @click="allPass(0)">驳回</el-button>
          </div>
        </template>
      </div>
      <div class="detail-info">
        <div class="detail-item">
          <div class="item-name">主题名称</div>
          <div class="item-value">{{detailInfo.themeName}}</div>
        </div>
        <div class="detail-item">
          <div class="item-name">渠道</div>
          <div class="item-value">{{detailInfo.channelName}}</div>
        </div>
        <div class="detail-item">
          <div class="item-name">活动名称</div>
          <div class="item-value">{{detailInfo.privateThemeName}}</div>
        </div>
        <div class="detail-item">
          <div class="item-name">所属区域</div>
          <div class="item-value">{{detailInfo.orgName}}</div>
        </div>
        <div class="detail-item">
          <div class="item-name">已选Area</div>
          <div class="item-value">
            <span style="margin-right:20px;padding-bottom:9px" v-for="item in areaList" :key="item.areaCode">{{item.orgName.split('|')[0]}}</span>
          </div>
        </div>
        <div class="detail-item">
          <div class="item-name">活动时间</div>
          <div class="item-value">{{detailInfo.startDate | parseTime('{y}-{m}-{d}')}}至{{detailInfo.endDate | parseTime('{y}-{m}-{d}')}}</div>
        </div>
        <div class="detail-item">
          <div class="item-name">最少执行时间（天）</div>
          <div class="item-value">{{detailInfo.execDaysMin}}</div>
        </div>
        <div class="detail-item">
          <div class="item-name">打卡频次（天/次）</div>
          <div class="item-value">{{detailInfo.execDaysCycle}}</div>
        </div>
        <div class="detail-item-nowrap">
          <div class="item-name">陈列追踪方式</div>
          <div class="item-value">{{detailInfo.trackTypeNameScope}}</div>
        </div>
        <div class="detail-item-nowrap">
          <div class="item-name">费用返还方式</div>
          <div class="item-value">{{detailInfo.bonusTypeNameScope}}</div>
        </div>
        <div class="detail-item" v-if="detailInfo.entryBrandCodeName">
          <div class="item-name">入账品牌</div>
          <div class="item-value">{{detailInfo.entryBrandCodeName}}</div>
        </div>
        <div class="detail-item" v-if="detailInfo.tradeBudgetTypeDTO">
          <div class="item-name">预算池</div>
          <div
            class="item-value"
          >{{`${detailInfo.tradeBudgetTypeDTO.typeName} (${detailInfo.tradeBudgetTypeDTO.trCodeName}) - 可用预算：`}}{{detailInfo.tradeBudgetTypeDTO.tradeBudgetInfoCountDTO.availableAmount | thousandSymbol}}</div>
        </div>
        <div class="detail-item-bonus" v-if="detailInfo.bonusTypeScope && detailInfo.bonusTypeScope.indexOf('01') !== -1">
          <div class="item-name">线上现金返还设置</div>
          <div class="item-value">
            <div>
              <div class="bonus-name">陈列费/次（元）</div>
              <div class="bonus-value">
                <div
                  v-if="detailInfo.bonusFeeChooseType === '01'"
                >{{detailInfo.bonusFeeMin | thousandSymbol}} - {{detailInfo.bonusFeeMax | thousandSymbol}}</div>
                <div class="item-value" v-if="detailInfo.bonusFeeChooseType === '02'">
                  <span v-for="item,index in detailInfo.bonusFeeScope.split(',')" :key="index">
                    {{item | thousandSymbol}}
                    <i v-if="index !== detailInfo.bonusFeeScope.split(',').length - 1">，</i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="detail-item-bonus" v-if="detailInfo.bonusTypeScope && detailInfo.bonusTypeScope.indexOf('02') !== -1">
          <div class="item-name">线下现金返还设置</div>
          <div class="item-value">
            <div>
              <div class="bonus-name">陈列费/次（元）</div>
              <div class="bonus-value">
                <div
                  v-if="detailInfo.offlineFeeChooseType === '01'"
                >{{detailInfo.offlineFeeMin | thousandSymbol}} - {{detailInfo.offlineFeeMax | thousandSymbol}}</div>
                <div class="item-value" v-if="detailInfo.offlineFeeChooseType === '02'">
                  <span v-for="item,index in detailInfo.offlineFeeScope.split(',')" :key="index">
                    {{item | thousandSymbol}}
                    <i v-if="index !== detailInfo.offlineFeeScope.split(',').length - 1">，</i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="detail-item-bonus" v-if="detailInfo.bonusTypeScope && detailInfo.bonusTypeScope.indexOf('03') !== -1">
          <div class="item-name">线下免费酒返还设置</div>
          <div class="item-value">
            <div>
              <div class="bonus-name">赠酒SKU</div>
              <div class="bonus-value">
                <span class="sku-item" v-for="item in sku" :key="item.skuName">{{item.skuName}}</span>
              </div>
            </div>
            <div>
              <div class="bonus-name">赠酒数/次（箱）</div>
              <div class="bonus-value">
                <div
                  v-if="detailInfo.bonusBeerChooseType === '01'"
                >{{detailInfo.bonusBeerMin | thousandSymbol}} - {{detailInfo.bonusBeerMax | thousandSymbol}}</div>
                <div v-if="detailInfo.bonusBeerChooseType === '02'">
                  <span v-for="item,index in detailInfo.bonusBeerQtyScope.split(',')" :key="index">
                    {{item | thousandSymbol}}
                    <i v-if="index !== detailInfo.bonusBeerQtyScope.split(',').length - 1">，</i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 先蜂购线上免费酒设置 -->
        <div class="detail-item-bonus bonus" v-if="tradePerfectBonusBeerGroupList.length">
          <div class="bonus-title">
            先蜂购线上免费酒返还设置
            <el-button
              class="btn-red"
              style="width:80px;float:right;"
              @click="toUpdateBonusStr"
              v-if="detailInfo.publishStatus === 1 && detailInfo.themeStatus === 200 && employeeLevel === 50 && detailInfo.modifyStatus !== 100"
            >编辑</el-button>
          </div>
          <div class="bonus-content">
            <RegionBeesBonusBeer ref="BonusBeerOnline" :monthList="monthList" :dataList="tradePerfectBonusBeerGroupList" type="show"></RegionBeesBonusBeer>
            <div class="coupon-bonus-beer" style="width:100%">
              <div style="width:17%">
                <i>*</i> 赠酒券有效时间
              </div>
              <div style="width:70%" v-if="false">
                <div>
                  <el-radio v-model="beesCouponAssignRule.type" label="01">&nbsp;</el-radio>发券后
                  <el-input-number v-model="beesCouponAssignRule.validDays" :min="0" :precision="0" style="margin:0 5px" placeholder="请输入"></el-input-number>天内
                </div>
                <div>
                  <el-radio v-model="beesCouponAssignRule.type" label="02">&nbsp;</el-radio>永久有效
                </div>
              </div>
              <div v-else>
                <div v-if="beesCouponAssignRule.type === '01'">发券后 {{beesCouponAssignRule.validDays}} 天内</div>
                <div v-if="beesCouponAssignRule.type === '02'">永久有效</div>
              </div>
            </div>
          </div>
        </div>
        <!-- 先蜂购线上折扣金返还设置 -->
        <div class="detail-item-bonus" v-if="detailInfo.bonusTypeScope && detailInfo.bonusTypeScope.indexOf('05') !== -1">
          <div class="item-name">先蜂购线上折扣金返还设置</div>
          <div class="item-value">
            <div>
              <div class="bonus-name">折扣金/次（元）</div>
              <div class="bonus-value">
                <div
                  v-if="detailInfo.beesFeeChooseType === '01'"
                >{{detailInfo.beesFeeMin | thousandSymbol}} - {{detailInfo.beesFeeMax | thousandSymbol}}</div>
                <div class="item-value" v-if="detailInfo.beesFeeChooseType === '02'">
                  <span v-for="item,index in detailInfo.beesFeeScope.split(',')" :key="index">
                    {{item | thousandSymbol}}
                    <i v-if="index !== detailInfo.beesFeeScope.split(',').length - 1">，</i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 执行任务信息 -->
      <div class="exec-task-info" v-show="taskCheckedList.length">
        <!-- tab栏 -->
        <el-tabs v-model="activeName">
          <template v-for="item in taskCheckedList">
            <el-tab-pane v-if="item.checked" :key="item.key" :label="item.title" :name="item.title"></el-tab-pane>
          </template>
        </el-tabs>
        <!-- 选项卡 -->
        <!-- 堆箱任务 -->
        <div class="tab-content" v-show="activeName==='堆箱任务'">
          <DisplayPackDesign
            type="view"
            v-show="taskPackSelected.mixinPackScopeList && taskPackSelected.mixinPackScopeList.length"
            :selectedData="taskPackSelected.mixinPackScopeList"
          ></DisplayPackDesign>
          <DisplayMixin
            type="view"
            v-show="taskPackSelected.mixinDisplayScopeList && taskPackSelected.mixinDisplayScopeList.length"
            :selectedData="taskPackSelected.mixinDisplayScopeList"
          ></DisplayMixin>
        </div>
        <!-- 货架任务 -->
        <div class="tab-content" v-show="activeName==='货架任务'">
          <DisplayMandatory
            type="view"
            v-show="taskShelfSelected.mandatoryScopeList && taskShelfSelected.mandatoryScopeList.length"
            :selectedData="taskShelfSelected.mandatoryScopeList"
          ></DisplayMandatory>
          <DisplayMixin
            type="view"
            v-show="taskShelfSelected.mixinDisplayScopeList && taskShelfSelected.mixinDisplayScopeList.length"
            :selectedData="taskShelfSelected.mixinDisplayScopeList"
          ></DisplayMixin>
        </div>
        <!-- 冰柜任务 -->
        <div class="tab-content" v-show="activeName==='冰柜任务'">
          <DisplayMandatory
            type="view"
            v-show="taskFreezerSelected.mandatoryScopeList && taskFreezerSelected.mandatoryScopeList.length"
            :selectedData="taskFreezerSelected.mandatoryScopeList"
          ></DisplayMandatory>
          <DisplayMixin
            type="view"
            v-show="taskFreezerSelected.mixinDisplayScopeList && taskFreezerSelected.mixinDisplayScopeList.length"
            :selectedData="taskFreezerSelected.mixinDisplayScopeList"
          ></DisplayMixin>
        </div>
        <!-- STR任务 -->
        <div class="tab-content" v-show="activeName==='STR任务'">
          <RegionStr
            ref="regionStr"
            :strTaskList="strTaskInfo.saleScopeList"
            :monthList="monthList"
            :edit="false"
            @toUpdateBonusStr="toUpdateBonusStr"
            :isDetailPage="true"
          >
            <el-button
              type="primary"
              class="btn-red"
              size="medium"
              @click="toUpdateBonusStr"
              v-if="detailInfo.publishStatus === 1 && detailInfo.themeStatus === 200 && employeeLevel === 50 && detailInfo.modifyStatus !== 100"
            >编辑</el-button>
          </RegionStr>
        </div>
      </div>
      <div class="nothing" v-if="!taskCheckedList.length">您暂未配置执行任务信息</div>
      <!-- 操作记录 -->
      <div class="title">
        <span>操作记录</span>
      </div>
      <div class="handle-history">
        <el-table :data="history" style="width: 100%" :border="true">
          <el-table-column prop="processClientName" label="操作人" align="center">
            <template #default="scope">
              <div>{{scope.row.employeeLevelName + ' - ' + scope.row.processClientName}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="processActionName" label="操作" align="center"></el-table-column>
          <el-table-column prop="processRemark" label="备注" align="center"></el-table-column>
          <el-table-column prop="processTime" label="时间" align="center">
            <template #default="scope">{{scope.row.processTime | parseTime("{y}-{m}-{d} {h}:{i}:{s}")}}</template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import tradeApi from '@/api/trade'
import moment from 'moment'
import ContentHeader from '@/components/content-header'
import RegionBeesBonusBeer from '@/views/trade/perfect2022/components/region-bees-bonus-beer.vue'
import DisplayPackDesign from '@/views/trade/perfect2022/components/display-pack-design'
import DisplayMixin from '@/views/trade/perfect2022/components/display-mixin'
import DisplayMandatory from '@/views/trade/perfect2022/components/display-mandatory'
import RegionStr from '@/views/trade/perfect2022/components/region-str.vue'
import { mapGetters } from 'vuex'
export default {
  components: {
    ContentHeader,
    DisplayPackDesign,
    DisplayMixin,
    DisplayMandatory,
    RegionBeesBonusBeer,
    RegionStr
  },
  computed: {
    ...mapGetters(['userInfo']),
    sku () {
      let list = []
      if (this.detailInfo.bonusBeerScope) {
        list = JSON.parse(this.detailInfo.bonusBeerScope)
      }
      return list
    },
    beesCouponAssignRule () {
      let obj = {}
      if (this.detailInfo.beesCouponAssignRule) {
        obj = JSON.parse(this.detailInfo.beesCouponAssignRule)
      }
      return obj
    },
    budget () {
      let obj = {}
      if (this.detailInfo.budgetInfoList) {
        obj = this.detailInfo.budgetInfoList[0]
      }
      return obj
    },
    active () {
      let status = null
      switch (this.detailInfo.themeStatus) {
        case 0:
          status = 0
          break
        case 100:
          status = 1
          break
        case 200:
          status = 2
          break
        case 900:
          status = 3
          break
      }
      return status
    },
    isBonusTypeBeer () {
      return this.detailInfo.bonusTypeScope?.indexOf('03') !== -1
    },
    isBonusTypeFee () {
      return this.detailInfo.bonusTypeScope?.indexOf('02') !== -1 || this.detailInfo.bonusTypeScope?.indexOf('01') !== -1
    },
    isBonusTypeFeeOnLine () {
      return this.detailInfo.bonusTypeScope?.indexOf('01') !== -1
    }
  },
  data () {
    return {
      loading: false,
      activeName: '堆箱任务',
      taskCheckedList: [],
      detailInfo: {},
      taskPackSelected: [],
      taskShelfSelected: [],
      taskFreezerSelected: [],
      history: [],
      employeeLevel: null,
      areaList: [],
      monthList: [],
      tradePerfectBonusBeerGroupList: [],
      strTaskInfo: {},
      tips: ''
    }
  },
  created () {
    this.employeeLevel = this.userInfo.employeeLevel
    this.getDetailInfo()
  },
  methods: {
    // 获取活动详情
    getDetailInfo () {
      this.loading = true
      tradeApi.getBuPerfectTasksConfigInfo({ themeDefineId: this.$route.query.themeDefineId }).then(res => {
        if (res.data.resultCode === '0') {
          this.loading = false
          this.detailInfo = res.data.resultData.tradePerfectThemeDefineDTO
          this.history = res.data.resultData.tradePerfectThemeDefineDTO.commonProcessRecordDTOList
          this.getTask()
          this.getTaskCheckedList()
          // this.getHandleHistory()
          this.getAreaList()
          this.getReportCycle()
          if (this.detailInfo.bonusTypeScope.indexOf('04') !== -1) {
            this.tradePerfectBonusBeerGroupList = this.detailInfo.tradePerfectBonusBeerGroupList
          }
          if (this.employeeLevel <= 50) {
            if (this.detailInfo.modifyStatus === 0) {
              this.tips = '当前活动配置修改内容已保存，请及时提交审批！'
            }
            if (this.detailInfo.modifyStatus === 100) {
              this.tips = '当前活动配置修改已提交审批，请耐心等待审批！'
            }
          }
        }
      })
    },
    // 获取areaList
    getAreaList () {
      tradeApi.getAreaList({ regionCode: this.detailInfo.orgCode }).then(res => {
        if (res.data.resultCode === '0') {
          let list = res.data.resultData.regionList
          if (this.detailInfo.areaCodes && this.detailInfo.areaCodes.length) {
            this.areaList = this.detailInfo.areaCodes.split(',').map(item => {
              for (let i = 0; i < list.length; i++) {
                if (list[i].orgCode === item) {
                  return list[i]
                }
              }
            })
          } else {
            this.areaList = list
          }
        }
      })
    },
    // 获取已选择任务
    getTask () {
      this.detailInfo.tradePerfectTaskDefineList.forEach(item => {
        if (item.taskType === '01') {
          this.taskPackSelected = item
        } else if (item.taskType === '02') {
          this.taskShelfSelected = item
        } else if (item.taskType === '03') {
          this.taskFreezerSelected = item
        } else if (item.taskType === '05') {
          this.strTaskInfo = item
        }
      })
    },
    // 任务选项卡
    getTaskCheckedList () {
      if (!this.detailInfo.taskTypeScope.length) {
        return
      }
      this.taskCheckedList = this.detailInfo.taskTypeScope.split(',').map(item => {
        item = { key: item }
        item.checked = true
        if (item.key === '01') {
          item.title = '堆箱任务'
        } else if (item.key === '02') {
          item.title = '货架任务'
        } else if (item.key === '03') {
          item.title = '冰柜任务'
        } else if (item.key === '05') {
          item.title = 'STR任务'
        }
        return item
      })
      this.activeName = this.taskCheckedList[0].title
    },
    // 复制
    handleCopy () {
      this.$router.push({
        path: '/perfect-region-config',
        query: { type: 'copy', themeDefineId: this.detailInfo.themeDefineId, orgCode: this.detailInfo.orgCode }
      })
    },
    // 修改
    handleUpdate () {
      this.$router.push({
        path: '/perfect-region-config',
        query: { type: 'update', themeDefineId: this.detailInfo.themeDefineId, orgCode: this.detailInfo.orgCode }
      })
    },
    // 禁用
    handleDisable () {
      this.$prompt('请输入禁用原因:', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /\S+/,
        inputErrorMessage: '请输入禁用原因'
      }).then(({ value }) => {
        if (!value) {
          this.$message.warning('请填写禁用原因')
          return
        }
        tradeApi.handleRegionDisable({ themeDefineId: this.detailInfo.themeDefineId, processRemark: value }).then(res => {
          if (res.data.resultCode === '0') {
            this.$message.success('禁用成功')
            this.$router.go(0)
          }
        })
      }).catch(() => {

      })
    },
    // 启用
    handleEnable () {
      this.$prompt('请输入启用备注:', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(({ value }) => {
        tradeApi.handleRegionEnable({ themeDefineId: this.detailInfo.themeDefineId, processRemark: value }).then(res => {
          if (res.data.resultCode === '0') {
            this.$message.success('启用成功')
            this.$router.go(0)
          }
        })
      }).catch(() => {

      })
    },
    // 删除活动
    handleRemove (rowData) {
      this.$confirm(`是否删除活动:  ${this.detailInfo.privateThemeName}`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        tradeApi.handleRegionRemove({ themeDefineId: this.detailInfo.themeDefineId }).then(res => {
          if (res.data.resultCode === '0') {
            this.$message.success('删除成功')
            this.$router.push({
              path: '/trade/perfect-region-config-list'
            })
          }
        })
      }).catch(() => {

      })
    },
    // bu 审批
    allPass (themeStatus) {
      let params = [{ themeDefineId: this.$route.query.themeDefineId, themeStatus }]
      // let mag = themeStatus === 200 ? '审批通过' : '驳回'
      if (themeStatus === 200) {
        this.$prompt('请输入审批通过原因', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(({ value }) => {
          params.map(item => {
            item.processRemark = value
            return item
          })
          tradeApi.perfectApproval(params).then(res => {
            if (res.data.resultCode === '0') {
              this.$alert(`审批通过成功${res.data.resultMsg ? (',' + res.data.resultMsg) : ''}！`, '', {
                confirmButtonText: '确定',
                callback: action => {
                  this.$router.push({
                    path: '/trade/perfect-theme-approve'
                  })
                }
              })
            }
          })
        }).catch(() => { })
      } else {
        this.$prompt('请输入审批驳回原因', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPattern: /\S/,
          inputErrorMessage: '请输入审批驳回原因'
        }).then(({ value }) => {
          params.map(item => {
            item.processRemark = value
            return item
          })
          tradeApi.perfectApproval(params).then(res => {
            if (res.data.resultCode === '0') {
              // this.getApprovalList()
              this.$message.success('驳回成功')
              this.$router.push({
                path: '/trade/perfect-theme-approve'
              })
            }
          })
        }).catch(() => { })
      }
    },
    // monthList
    getReportCycle () {
      if (!this.detailInfo.startDate || !this.detailInfo.endDate) {
        return
      }
      let startDate = moment(moment(this.detailInfo.startDate).startOf('month').format('YYYY-MM-DD'))
      let endDate = moment(moment(this.detailInfo.endDate).endOf('month').format('YYYY-MM-DD'))
      let startYear = startDate.format('YYYY')
      let startMonth = startDate.format('M')
      let list = []
      for (let i = startMonth; i < endDate.diff(startDate, 'months') + 1 + parseInt(startMonth); i++) {
        let month = (i % 12) === 0 ? 12 : (i % 12)
        let num = i % 12 === 0 ? Math.floor(i / 12) - 1 : Math.floor(i / 12)
        let year = parseInt(startYear) + num
        let obj = {
          year,
          month: month > 9 ? month + '' : '0' + month
        }
        list.push(obj)
      }
      this.monthList = list
    },
    // 编辑先蜂购线上免费酒返还设置
    toUpdateBonusStr () {
      this.$router.push({
        path: '/perfect-region-update',
        query: { themeDefineId: this.detailInfo.themeDefineId }
      })
    },
    // 生效中活动修改 (取消、提交、召回)
    updateApprove (mode) {
      let params = {
        themeDefineId: this.detailInfo.themeDefineId,
        saveFlag: ''
      }
      let message = ''
      let successMessage = ''
      if (mode === 0) {
        message = '请输入放弃当前活动配置修改备注：'
        successMessage = '当前活动配置修改已取消'
      } else if (mode === 1) {
        message = '请输入召回当前活动配置审批备注：'
        successMessage = '当前活动配置审批已召回可继续修改'
      } else if (mode === 2) {
        message = '请输入提交审批备注：'
        successMessage = '已成功提交，BU TM审批后生效'
      }
      params.saveFlag = mode
      this.$prompt(`${message}`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info '
      }).then(({ value }) => {
        params.processRemark = value
        this.loading = true
        tradeApi.handleUpdateApproveStatus(params).then(res => {
          this.loading = false
          if (res.data.resultCode === '0') {
            this.$message.success(`${successMessage}`)
            this.$router.go(0)
          }
        }).catch(() => {
          this.loading = false
        })
      }).catch(() => {
      })
    }
  }

}
</script>

<style lang="scss" scoped>
::v-deep .el-step__title.is-process,
::v-deep .el-step__head.is-process {
  color: #cd1231;
  border-color: #cd1231;
  font-weight: 400;
}
::v-deep .el-step__head.is-success,
::v-deep .el-step__head.is-process {
  font-size: 14px;
}
::v-deep .el-input-number__decrease,
::v-deep .el-input-number__increase {
  display: none;
}
::v-deep .el-input-number .el-input__inner {
  padding: 0;
}
.el-input-number {
  width: 80px;
  &::v-deep .el-input__inner {
    padding: 0;
  }
}
::v-deep .el-input .el-input__inner {
  height: 30px;
}
.el-button {
  min-width: 50px;
  height: 30px;
  padding: 0 10px;
}
.content-container {
  width: 1200px;
  .steps {
    padding: 25px 100px;
    background-color: #fff;
    border-radius: 10px;
  }
  .steps-disable {
    background-color: #fff;
    color: #cd1231;
    text-align: center;
    padding: 50px 0;
  }
  .title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    span {
      font-size: 18px;
      font-weight: 700;
      line-height: 60px;
      padding-left: 10px;
    }
  }
  .detail-info {
    display: flex;
    flex-wrap: wrap;
    background-color: #fff;
    padding: 20px;
    border-radius: 10px;
    margin-bottom: 40px;
    .detail-item {
      width: 50%;
      display: flex;
      flex-wrap: wrap;
      .item-name {
        // width: 130px;
        height: 48px;
        // flex-basis: 25%;
        width: 145px;
        padding-left: 10px;
      }
      .item-value {
        width: 406px;
        // flex-basis: 70%;
        white-space: normal;
        word-break: break-all;
        word-wrap: break-word;
      }
    }
    .detail-item-nowrap {
      display: flex;
      flex-wrap: wrap;
      flex-basis: 100%;
      .item-name {
        width: 145px;
        height: 48px;
        padding-left: 10px;
      }
      .item-value {
        // flex-basis: 88%;
        flex: 1;
        white-space: normal;
        word-break: break-all;
        word-wrap: break-word;
      }
    }
    .detail-item-bonus {
      width: 100%;
      background-color: #f8f8f8;
      margin-bottom: 20px;
      border-radius: 6px;
      padding: 20px 10px 0;
      .item-name {
        // width: 145px;
        height: 48px;
        font-weight: 700;
      }
      .item-value {
        & > div {
          width: 100%;
          display: flex;
        }
        .bonus-name {
          width: 145px;
          height: 48px;
        }
        .bonus-value {
          flex: 1;
        }
      }
    }
  }
}
// // 任务tabs样式
::v-deep .el-tabs {
  .el-tabs__header {
    border-bottom: none;
  }
  .el-tabs__nav {
    border: none;
    border-radius: 10px 10px 0px 0px;
    background-color: #fff;
    padding: 10px 20px 0px;
  }
  .el-tabs__header {
    margin: 0;
  }
  .el-tabs__nav-wrap::after {
    background-color: #f3f5f9;
  }
  .el-tabs__active-bar {
    margin: 0 20px 0;
    background-color: rgb(234, 84, 5);
  }
  .el-tabs__item.is-active {
    font-weight: 700;
    color: rgb(234, 84, 5);
  }
  .el-tabs__item:hover {
    color: rgb(234, 84, 5);
  }
}
.tab-content {
  font-size: 16px;
  border-radius: 0px 10px 10px 10px;
  overflow: hidden;
  position: relative;
  .tab-item {
    background-color: #fff;
    padding: 20px 20px;
  }
}
.place-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #fff;
  padding: 20px 20px 0;
  p {
    font-weight: 700;
    margin: 0;
  }
  .el-button {
    width: 80px;
  }
}
.handle-history {
  background-color: #fff;
  border-radius: 10px;
  padding: 30px;
}
.btn-green {
  background-color: #64d795;
  color: #fff;
}
.encourage {
  margin-bottom: 5px;
  background-color: #fff;
  padding: 30px 20px 20px;
  p {
    font-weight: 700;
    margin-top: 0;
    font-size: 16px;
  }
  .encourage-input {
    display: flex;
    &::v-deep .el-input .el-input__inner {
      height: 30px;
    }
    .el-input {
      width: 135px;
      height: 30px;
    }
    span {
      line-height: 38px;
      font-size: 14px;
      margin-right: 20px;
    }
  }
}
.nothing {
  text-align: center;
  background-color: #fff;
  padding: 120px 0;
  border-radius: 10px;
}
.sku-item {
  line-height: 24px;
  // margin-bottom: 10px;
  // display: block;
  height: 48px;
  margin-right: 10px;
  padding-left: 5px;
}
.bonus {
  background-color: #f8f8f8;
  border-radius: 10px;
  padding: 0px 10px;
  margin-bottom: 10px;
  box-sizing: border-box;
  // line-height: 40px;
  .bonus-title {
    font-size: 14px;
    font-weight: 700;
    // padding-left: 20px;
    box-sizing: border-box;
  }
  .bonus-content {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    i {
      color: #c8102d;
      font-size: 16px;
      font-weight: 700;
      margin-right: 10px;
    }
    .el-radio {
      margin-right: 10px;
    }
    .el-radio ::v-deep .el-radio__input {
      display: inline-block;
    }
    .el-radio ::v-deep .el-radio__input.is-checked + .el-radio__label {
      color: #606266;
    }
    .coupon-bonus-beer {
      display: flex;
      line-height: 40px;
      margin: 20px 0 10px;
    }
  }
}
</style>
